export class UnsupportedError extends Error {
  constructor(feature: string, options?: ErrorOptions) {
    super(`${feature} is not supported`, options);
  }
}
